/* PA Naturals - "Chat with Maddy" add-on (isolated).
   - Reads real products from existing collections via Shopify's storefront JSON
     (/collections/<handle>/products.json). Only variants that are available and
     priced above 0 are shown.
   - Adds to cart with Shopify's standard /cart/add.js, re-reads /cart.js, then
     dispatches the theme's normal 'cart:update' event (same shape as Horizon's
     CartUpdateEvent) so the cart icon, cart drawer and Maddy's existing cart
     reactions update as usual.
   - Does not call into or modify assets/pa-buddy.js. All DOM is inside .pa-mchat. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') n.className = attrs[k]; else n.setAttribute(k, attrs[k]);
    });
    if (text != null) n.textContent = text;
    return n;
  }
  function money(p) {
    var v = Number(p);
    return isNaN(v) ? '' : 'Rs. ' + v.toFixed(2);
  }
  function sellable(v) { return v && v.available === true && Number(v.price) > 0; }

  function init(wrap) {
    if (wrap.__paMchat) return;
    wrap.__paMchat = true;
    var cfg = {};
    var cfgEl = wrap.querySelector('[data-pa-mchat-data]');
    try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}') || {}; } catch (e) { cfg = {}; }
    var collections = Array.isArray(cfg.collections) ? cfg.collections : [];
    var greeting = cfg.greeting || 'Hi! I’m Maddy!';
    var openBtn = wrap.querySelector('[data-pa-mchat-open]');
    var panel = wrap.querySelector('[data-pa-mchat-panel]');
    var closeBtn = wrap.querySelector('[data-pa-mchat-close]');
    var body = wrap.querySelector('[data-pa-mchat-body]');
    if (!openBtn || !panel || !closeBtn || !body) return;

    var built = false;
    function build() {
      if (built) return; built = true;
      body.appendChild(el('p', { class: 'pa-mchat__msg' }, greeting + ' What would you like to shop for today?'));
      buildHelp();
      var chips = el('div', { class: 'pa-mchat__chips', role: 'group', 'aria-label': 'Choose a category' });
      var list = el('div', { class: 'pa-mchat__list', 'aria-live': 'polite' });
      collections.forEach(function (c) {
        if (!c || !c.handle) return;
        var chip = el('button', { class: 'pa-mchat__chip', type: 'button', 'aria-pressed': 'false' }, c.title || c.handle);
        chip.addEventListener('click', function () {
          chips.querySelectorAll('.pa-mchat__chip').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          chip.setAttribute('aria-pressed', 'true');
          loadCollection(c, list);
        });
        chips.appendChild(chip);
      });
      if (!chips.children.length) body.appendChild(el('p', { class: 'pa-mchat__msg' }, 'No categories are available right now.'));
      body.appendChild(chips);
      body.appendChild(list);
      buildSearch();
    }

    function revealList(list) {
      try {
        var top = list.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop - 8;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (body.scrollTo) body.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' }); else body.scrollTop = Math.max(0, top);
      } catch (e) { /* non-critical */ }
    }

    /* ---- Stage 1a: help topics, policy answers and support handoff (added 14 Oct 2026) ----
       Answers quote the store's own live policy pages; nothing is invented or stored.
       Contacts come from section settings (support_email; WhatsApp only when switched on). */
    var support = (cfg && cfg.support) || {};
    var supportEmail = /^[^\s@<>"]+@[^\s@<>"]+\.[^\s@<>"]+$/.test(String(support.email || '').trim()) ? String(support.email).trim() : '';
    var supportWa = String(support.whatsapp || '').replace(/\D/g, '');
    if (supportWa.length < 10) supportWa = '';
    var policyCache = {};
    var helpSeq = 0;

    function msg(text, cls) { return el('p', { class: 'pa-mchat__msg' + (cls ? ' ' + cls : '') }, text); }
    function policyUrl(kind) {
      var u = kind === 'shipping' ? support.shippingUrl : support.refundUrl;
      return u || (root + 'policies/' + (kind === 'shipping' ? 'shipping-policy' : 'refund-policy'));
    }
    function loadPolicy(kind) {
      if (policyCache[kind]) return Promise.resolve(policyCache[kind]);
      return fetch(policyUrl(kind), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var b = doc.querySelector('.shopify-policy__body') || doc.querySelector('.rte');
          if (!b) throw new Error('No policy text');
          var blocks = [];
          b.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6').forEach(function (n) {
            var t = (n.textContent || '').replace(/\s+/g, ' ').trim();
            if (!t) return;
            var strongOnly = n.tagName === 'P' && n.children.length === 1 && n.firstElementChild.tagName === 'STRONG' &&
              (n.firstElementChild.textContent || '').replace(/\s+/g, ' ').trim() === t;
            var shortLabel = n.tagName === 'P' && t.length <= 60 && t.split(' ').length <= 8 && !/[.!?:,;]$/.test(t);
            blocks.push({ text: t, heading: /^H\d$/.test(n.tagName) || strongOnly || shortLabel });
          });
          if (!blocks.length) {
            var all = (b.textContent || '').replace(/\s+/g, ' ').trim();
            if (!all) throw new Error('Empty policy');
            blocks.push({ text: all, heading: false });
          }
          policyCache[kind] = blocks;
          return blocks;
        });
    }
    function pickSections(blocks, re) {
      var groups = [], cur = null;
      blocks.forEach(function (b) {
        if (b.heading || !cur) { cur = { head: b.heading ? b : null, items: [] }; groups.push(cur); if (b.heading) return; }
        cur.items.push(b);
      });
      var picked = [];
      groups.forEach(function (g, gi) {
        if (gi === 0 && g.head === blocks[0]) return; /* skip the policy title */
        if (g.head && g.items.length && re.test(g.head.text)) picked = picked.concat([g.head], g.items);
      });
      if (!picked.length) picked = blocks.filter(function (b) { return !b.heading && re.test(b.text); });
      return picked.length ? picked : blocks;
    }
    function renderBlocks(target, blocks) {
      var box = el('div', { class: 'pa-mchat__msg pa-mchat__policy' });
      blocks.forEach(function (bl) {
        box.appendChild(bl.heading ? el('strong', { class: 'pa-mchat__ph' }, bl.text) : el('p', null, bl.text));
      });
      target.appendChild(box);
    }
    function linkMsg(href, text) {
      var p = el('p', { class: 'pa-mchat__msg' });
      p.appendChild(el('a', { href: href }, text));
      return p;
    }
    function safetyNote() {
      return el('p', { class: 'pa-mchat__safe' }, 'For your safety, never share card numbers, UPI PIN, OTPs or passwords in chat, by email or on WhatsApp.');
    }
    function contactBlock(target) {
      var box = el('div', { class: 'pa-mchat__msg pa-mchat__contact' });
      var ul = el('ul', { class: 'pa-mchat__links' });
      var li;
      if (supportEmail) {
        li = el('li');
        li.appendChild(el('a', { href: 'mailto:' + supportEmail + '?subject=' + encodeURIComponent('PA Naturals customer support') }, 'Email us: ' + supportEmail));
        ul.appendChild(li);
      }
      if (supportWa) {
        li = el('li');
        li.appendChild(el('a', { href: 'https://wa.me/' + supportWa, target: '_blank', rel: 'noopener noreferrer' }, 'Message us on WhatsApp'));
        ul.appendChild(li);
      }
      if (support.contactUrl) {
        li = el('li');
        li.appendChild(el('a', { href: support.contactUrl }, 'Contact page'));
        ul.appendChild(li);
      }
      if (!ul.children.length) {
        box.appendChild(el('p', null, 'Please use the contact details on our website to reach the PA Naturals team.'));
      } else {
        box.appendChild(el('p', null, 'You can reach the PA Naturals team here:'));
        box.appendChild(ul);
        box.appendChild(el('p', null, 'If your message is about an order, please include your order number.'));
      }
      box.appendChild(safetyNote());
      target.appendChild(box);
    }

    var TOPICS = [
      { label: 'Shipping & delivery', kind: 'shipping', intro: 'Here’s what our shipping policy says:', linkText: 'Read the full shipping policy' },
      { label: 'Track my order', kind: 'shipping', re: /track|question/i, intro: 'From our shipping policy:', linkText: 'Read the full shipping policy',
        after: function (a) { orderHelp(a); contactBlock(a); } },
      { label: 'Returns & refunds', kind: 'refund', intro: 'Here’s what our return, refund and cancellation policy says:', linkText: 'Read the full policy', after: contactBlock },
      { label: 'Cancel an order', kind: 'refund', re: /cancel|reach/i, intro: 'From our return, refund and cancellation policy:', linkText: 'Read the full policy', after: contactBlock },
      { label: 'Prices & payment', render: function (a) {
          a.appendChild(msg('Prices for each size are shown on every product page and in the categories below. Any shipping charges, and the payment options available to you, are shown at checkout before you pay.'));
          var p = el('div', { class: 'pa-mchat__msg' });
          p.appendChild(safetyNote());
          a.appendChild(p);
        } },
      { label: 'Talk to a person', render: function (a) { contactBlock(a); } }
    ];

    function showTopic(t, answer) {
      var seq = ++helpSeq;
      answer.textContent = '';
      if (!t.kind) { t.render(answer); revealList(answer); return; }
      answer.appendChild(msg('Loading…'));
      loadPolicy(t.kind).then(function (blocks) {
        if (seq !== helpSeq) return;
        answer.textContent = '';
        answer.appendChild(msg(t.intro));
        renderBlocks(answer, t.re ? pickSections(blocks, t.re) : blocks);
        answer.appendChild(linkMsg(policyUrl(t.kind), t.linkText));
        if (t.after) t.after(answer);
        revealList(answer);
      }).catch(function () {
        if (seq !== helpSeq) return;
        answer.textContent = '';
        var p = el('p', { class: 'pa-mchat__msg', role: 'alert' }, 'Sorry, I couldn’t load that just now. ');
        p.appendChild(el('a', { href: policyUrl(t.kind) }, 'Open the policy page'));
        answer.appendChild(p);
        contactBlock(answer);
        revealList(answer);
      });
    }

    function buildHelp() {
      body.appendChild(msg('Have a question about delivery, returns or an order? Pick a topic:'));
      var hchips = el('div', { class: 'pa-mchat__chips pa-mchat__chips--help', role: 'group', 'aria-label': 'Help topics' });
      var answer = el('div', { class: 'pa-mchat__answer', 'aria-live': 'polite' });
      TOPICS.forEach(function (t) {
        var chip = el('button', { class: 'pa-mchat__chip', type: 'button', 'aria-pressed': 'false' }, t.label);
        chip.addEventListener('click', function () {
          hchips.querySelectorAll('.pa-mchat__chip').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          chip.setAttribute('aria-pressed', 'true');
          showTopic(t, answer);
        });
        hchips.appendChild(chip);
      });
      body.appendChild(hchips);
      body.appendChild(answer);
      body.appendChild(msg('Or shop by category:'));
    }
    /* ---- end Stage 1a ---- */

    /* ---- Stage 1b: product questions and search (added 14 Oct 2026) ----
       Searches the store's own published product data (/products.json) inside the
       customer's browser; the typed text is not sent anywhere. Only variants that are
       available and priced above 0 are shown. Product details come only from the saved
       product description; nothing is invented. */
    var catalog = null, catalogReq = null, searchSeq = 0;
    var STOP = ' a an and any are can do does for from get give have how i in is it me much my need of on or please price prices cost costs rate show tell the there to want what which with you your buy available have got sell sold ';
    /* Reliable regional and alternative names -> words used in product titles. */
    var SYN = {
      munagaku: 'moringa munugaku drumstick', munugaku: 'moringa munugaku drumstick', munaga: 'moringa munugaku drumstick',
      moringa: 'moringa munugaku drumstick', drumstick: 'moringa munugaku drumstick',
      nuvvula: 'nuvvula sesame', nuvula: 'nuvvula sesame', nuvvulu: 'nuvvula sesame', nuvvu: 'nuvvula sesame', til: 'sesame nuvvula', sesame: 'sesame nuvvula',
      karivepaku: 'karvepaku curry', karvepaku: 'karvepaku curry', karepaku: 'karvepaku curry', kadipatta: 'karvepaku curry', curry: 'curry karvepaku',
      dhaniya: 'dhaniya coriander', dhania: 'dhaniya coriander', dhaniyalu: 'dhaniya coriander', coriander: 'coriander dhaniya',
      pasupu: 'turmeric', haldi: 'turmeric', turmeric: 'turmeric',
      mirchi: 'mirchi chilli', mirapakaram: 'mirchi chilli', karam: 'mirchi chilli', chilli: 'chilli mirchi', chili: 'chilli mirchi', chilly: 'chilli mirchi', chillies: 'chilli mirchi',
      allam: 'ginger', adrak: 'ginger', ginger: 'ginger',
      vellulli: 'garlic', velluli: 'garlic', lahsun: 'garlic', garlic: 'garlic',
      neyyi: 'ghee', nei: 'ghee', ghi: 'ghee', ghee: 'ghee',
      palli: 'groundnut', verusenaga: 'groundnut', peanut: 'groundnut', moongphali: 'groundnut', groundnut: 'groundnut',
      kobbari: 'coconut', nariyal: 'coconut', coconut: 'coconut',
      vepa: 'neem', neem: 'neem',
      laddu: 'laddoo', ladoo: 'laddoo', laddo: 'laddoo', ladu: 'laddoo', laddoos: 'laddoo', laddus: 'laddoo', laddoo: 'laddoo',
      halva: 'halwa', halwa: 'halwa', gajar: 'carrot', carrot: 'carrot', chukandar: 'beetroot', beet: 'beetroot', beetroot: 'beetroot',
      maramaralu: 'borugulu puffed', murmura: 'borugulu puffed', mamra: 'borugulu puffed', borugulu: 'borugulu puffed', puffed: 'puffed borugulu',
      dryfruit: 'dry fruit', dryfruits: 'dry fruit'
    };
    var SUPPORT_WORDS = [
      { re: /\b(pay|payment|upi|card\b|cards\b|cod\b|cash on delivery)/, topic: 'Prices & payment' },
      { re: /\b(ship|shipping|deliver|delivery|courier|dispatch)/, topic: 'Shipping & delivery' },
      { re: /\b(my account|sign in|signin|log in|login|order history|past orders|my orders)/, topic: 'Track my order' },
      { re: /\b(track|tracking|where is my order|order status)/, topic: 'Track my order' },
      { re: /\b(return|refund|damaged|broken|leak|wrong item|replace)/, topic: 'Returns & refunds' },
      { re: /\b(cancel)/, topic: 'Cancel an order' },
      { re: /\b(contact|human|person|agent|support|call|email|whatsapp|talk)/, topic: 'Talk to a person' }
    ];
    var DETAIL_RE = /\b(ingredient|ingredients|made of|contain|contains|shelf|expiry|expire|storage|store it|keep|benefit|benefits|healthy|nutrition|calorie|calories|protein|how to use|recipe|organic|preservative|preservatives|allergen|gluten|vegan)\b/;

    function norm(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    }
    function plainText(html) {
      var d = new DOMParser().parseFromString(String(html || ''), 'text/html');
      return (d.body.textContent || '').replace(/\s+/g, ' ').trim();
    }
    function editDistance(a, b) {
      if (Math.abs(a.length - b.length) > 2) return 3;
      var prev = [], cur, i, j;
      for (j = 0; j <= b.length; j++) prev[j] = j;
      for (i = 1; i <= a.length; i++) {
        cur = [i];
        for (j = 1; j <= b.length; j++) {
          cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        }
        prev = cur;
      }
      return prev[b.length];
    }
    function similar(a, b) {
      if (a === b) return 3;
      if (a.length >= 3 && b.indexOf(a) === 0) return 2;
      var lim = a.length >= 7 ? 2 : (a.length >= 4 ? 1 : 0);
      return lim && editDistance(a, b) <= lim ? 1 : 0;
    }
    function expandToken(t) {
      if (SYN[t]) return SYN[t].split(' ');
      if (t.length >= 6) {
        for (var k in SYN) { if (Object.prototype.hasOwnProperty.call(SYN, k) && k.length >= 6 && editDistance(t, k) <= (t.length >= 8 ? 2 : 1)) return SYN[k].split(' ').concat([t]); }
      }
      return [t];
    }
    function loadCatalog() {
      if (catalog) return Promise.resolve(catalog);
      if (catalogReq) return catalogReq;
      catalogReq = fetch(root + 'products.json?limit=250', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          catalog = (data.products || []).filter(function (p) { return (p.variants || []).some(sellable); }).map(function (p) {
            return { p: p, title: norm(p.title).split(' '), extra: norm([p.handle, p.product_type, (p.tags || []).join(' ')].join(' ')).split(' '), desc: plainText(p.body_html) };
          });
          return catalog;
        })
        .catch(function (e) { catalogReq = null; throw e; });
      return catalogReq;
    }
    function sizeWanted(q) {
      var m = String(q).toLowerCase().match(/(\d+(?:\.\d+)?)\s*(kgs?|kilo(?:gram)?s?|g|gm|gms|grams?|ml|l|ltrs?|litres?|liters?)\b/);
      if (!m) return null;
      var n = Number(m[1]), u = m[2];
      if (/^k/.test(u)) return n + ' kg';
      if (/^(l|lt|li)/.test(u)) return n + ' L';
      if (u === 'ml') return n + ' ml';
      return n + ' g';
    }
    /* Search fix (14 Oct 2026): words that name the kind of product. If a customer names one, a
       product must match it (so "sesame seeds" does not return a laddoo). */
    var FORM_WORDS = ' seed seeds powder powders paste pastes oil oils laddoo halwa ghee pickle pickles balm mix leaf leaves plant plants ';
    /* Search fix (14 Oct 2026): generic words. If a customer also types a specific word, a product
       must match a specific word too (so "cardamom powder" does not list every powder). */
    var GENERIC_WORDS = ' powder powders oil oils paste pastes mix leaf leaves seed seeds plant plants ';
    /* Search fix (14 Oct 2026): hide a duplicate listing from search when the preferred one is also found.
       Product records are not changed. Remove the line once the duplicate is deleted. */
    var SEARCH_PREFER = { 'munugaku-powder': 'moringa-powder' };
    function scoreProduct(entry, groups) {
      var total = 0, hits = 0, formMiss = false, specific = 0, specificHits = 0;
      groups.forEach(function (alts) {
        var best = 0;
        alts.forEach(function (w) {
          entry.title.forEach(function (t) { var c = similar(w, t); if (c) best = Math.max(best, c * 4); });
          entry.extra.forEach(function (t) { var c = similar(w, t); if (c) best = Math.max(best, c * 2); });
        });
        if (!alts.every(function (w) { return GENERIC_WORDS.indexOf(' ' + w + ' ') > -1; })) { specific++; if (best) specificHits++; }
        if (best) { hits++; total += best; }
        else if (alts.some(function (w) { return FORM_WORDS.indexOf(' ' + w + ' ') > -1; })) formMiss = true;
      });
      if (!hits || formMiss || (specific && !specificHits)) return { s: 0, all: false };
      var phrase = groups.map(function (a) { return a[0]; }).join(' ');
      var bonus = (' ' + entry.title.join(' ') + ' ').indexOf(' ' + phrase + ' ') > -1 ? 20 : 0;
      return { s: total + hits * 5 + bonus, all: hits === groups.length };
    }
    function searchCatalog(q) {
      var words = norm(q).replace(/\b\d+(\.\d+)?\s*(kgs?|g|gm|gms|grams?|ml|l|ltrs?|litres?|liters?)\b/g, ' ').split(' ').filter(function (w) {
        return w && !/^\d+$/.test(w) && STOP.indexOf(' ' + w + ' ') === -1;
      });
      var groups = words.map(expandToken);
      if (!groups.length) return [];
      var ranked = catalog.map(function (e) { var r = scoreProduct(e, groups); return { e: e, s: r.s, all: r.all }; })
        .filter(function (x) { return x.s > 0; })
        .sort(function (a, b) { return b.s - a.s; });
      if (!ranked.length) return [];
      var top = ranked[0];
      ranked = ranked.filter(function (x) { return x.s >= top.s * 0.6 && (!top.all || x.all); });
      var handles = ranked.map(function (x) { return x.e.p.handle; });
      ranked = ranked.filter(function (x) { var pref = SEARCH_PREFER[x.e.p.handle]; return !(pref && handles.indexOf(pref) > -1); });
      return ranked.slice(0, 5).map(function (x) { return x.e; });
    }
    function priceRange(p) {
      var vs = (p.variants || []).filter(sellable);
      if (vs.length < 2) return money(vs[0].price) + (vs[0].title && vs[0].title !== 'Default Title' ? ' (' + vs[0].title + ')' : '');
      var lo = vs[0], hi = vs[0];
      vs.forEach(function (v) { if (Number(v.price) < Number(lo.price)) lo = v; if (Number(v.price) > Number(hi.price)) hi = v; });
      return vs.length + ' sizes, from ' + money(lo.price) + ' (' + lo.title + ') to ' + money(hi.price) + ' (' + hi.title + ')';
    }
    function renderResults(out, q, results, wantsDetail) {
      var size = sizeWanted(q);
      out.appendChild(msg(results.length === 1 ? 'Here’s what I found:' : 'Here’s what I found for “' + q + '”:'));
      results.forEach(function (e) {
        var p = e.p;
        var info = el('div', { class: 'pa-mchat__msg pa-mchat__pinfo' });
        info.appendChild(el('strong', null, p.title));
        info.appendChild(el('p', null, priceRange(p)));
        if (e.desc) {
          info.appendChild(el('p', null, e.desc.length > 260 ? e.desc.slice(0, 257).replace(/\s+\S*$/, '') + '…' : e.desc));
        } else if (wantsDetail) {
          info.appendChild(el('p', null, 'No further details have been added for this product yet.'));
        }
        var more = el('p');
        more.appendChild(el('a', { href: root + 'products/' + p.handle }, 'View product page'));
        info.appendChild(more);
        out.appendChild(info);
        var c = card(p);
        if (size) {
          var sel = c.querySelector('select');
          if (sel) {
            var want = norm(size);
            for (var i = 0; i < sel.options.length; i++) {
              if (norm(sel.options[i].textContent) === want) { sel.value = sel.options[i].value; sel.dispatchEvent(new Event('change')); break; }
            }
          }
        }
        out.appendChild(c);
      });
      if (wantsDetail) {
        out.appendChild(msg('I can only share what’s on the product page. For anything not listed there, please ask the team.'));
        contactBlock(out);
      }
    }
    function supportTopicFor(nq) {
      for (var i = 0; i < SUPPORT_WORDS.length; i++) {
        if (SUPPORT_WORDS[i].re.test(nq)) {
          for (var j = 0; j < TOPICS.length; j++) if (TOPICS[j].label === SUPPORT_WORDS[i].topic) return TOPICS[j];
        }
      }
      return null;
    }
    function runSearch(q, out) {
      var seq = ++searchSeq;
      out.textContent = '';
      out.appendChild(el('p', { class: 'pa-mchat__msg pa-mchat__you' }, q));
      var nq = ' ' + norm(q) + ' ';
      var topic = supportTopicFor(nq);
      var wantsDetail = DETAIL_RE.test(nq);
      var loading = msg('Searching…');
      out.appendChild(loading);
      revealList(out);
      loadCatalog().then(function () {
        if (seq !== searchSeq) return;
        out.removeChild(loading);
        var results = searchCatalog(q);
        if (topic && !results.length) {
          var holder = el('div');
          out.appendChild(holder);
          showTopic(topic, holder);
          return;
        }
        if (!results.length) {
          out.appendChild(msg('Sorry, I couldn’t find a product matching “' + q + '” that’s available right now. Try another name, or browse a category above.'));
          var p = el('p', { class: 'pa-mchat__msg' }, 'Need help from a person? ');
          var b = el('button', { class: 'pa-mchat__chip', type: 'button' }, 'Talk to a person');
          b.addEventListener('click', function () { var h = el('div'); out.appendChild(h); showTopic(TOPICS[TOPICS.length - 1], h); });
          p.appendChild(b);
          out.appendChild(p);
          revealList(out);
          return;
        }
        renderResults(out, q, results, wantsDetail);
        if (topic) {
          var tp = el('p', { class: 'pa-mchat__msg' }, 'Also asking about ' + topic.label.toLowerCase() + '? ');
          var tb = el('button', { class: 'pa-mchat__chip', type: 'button' }, topic.label);
          tb.addEventListener('click', function () { var h = el('div'); out.appendChild(h); showTopic(topic, h); });
          tp.appendChild(tb);
          out.appendChild(tp);
        }
        revealList(out);
      }).catch(function () {
        if (seq !== searchSeq) return;
        if (loading.parentNode) out.removeChild(loading);
        out.appendChild(el('p', { class: 'pa-mchat__msg', role: 'alert' }, 'Sorry, I couldn’t search the shop just now. Please try again, or browse a category above.'));
        revealList(out);
      });
    }
    function buildSearch() {
      var out = el('div', { class: 'pa-mchat__results', 'aria-live': 'polite' });
      body.appendChild(out);
      var form = el('form', { class: 'pa-mchat__ask', role: 'search', 'aria-label': 'Ask Maddy about a product' });
      var inputId = 'pa-mchat-q-' + Math.random().toString(36).slice(2, 8);
      form.appendChild(el('label', { class: 'pa-mchat__sr', for: inputId }, 'Ask about a product'));
      var input = el('input', { id: inputId, class: 'pa-mchat__input', type: 'search', placeholder: 'Ask about a product, e.g. ghee 500 ml', autocomplete: 'off', maxlength: '80', enterkeyhint: 'search' });
      var go = el('button', { class: 'pa-mchat__go', type: 'submit' }, 'Ask');
      form.appendChild(input);
      form.appendChild(go);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = input.value.replace(/\s+/g, ' ').trim();
        if (!q) { input.focus(); return; }
        if (looksSensitive(q)) {
          input.value = '';
          searchSeq++;
          out.textContent = '';
          out.appendChild(el('p', { class: 'pa-mchat__msg pa-mchat__warn', role: 'alert' }, 'For your safety, I haven\u2019t searched or shown that message. Please don\u2019t share card numbers, CVV, OTPs, UPI PIN or passwords. PA Naturals will never ask for them.'));
          revealList(out);
          input.focus();
          return;
        }
        runSearch(q.slice(0, 80), out);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && input.value) { e.stopPropagation(); input.value = ''; }
      });
      var foot = panel.querySelector('.pa-mchat__foot');
      if (foot) panel.insertBefore(form, foot); else panel.appendChild(form);
      var note = el('p', { class: 'pa-mchat__note', id: inputId + '-note' }, 'Please don\u2019t share card, CVV, OTP, UPI PIN or password details here.');
      if (foot) panel.insertBefore(note, foot); else panel.appendChild(note);
      input.setAttribute('aria-describedby', note.id);
    }
    /* ---- end Stage 1b ---- */

    /* ---- Stage 1c: sensitive-data guard (added 14 Oct 2026) ----
       Runs in the browser before a typed message is searched or shown. Nothing is
       stored or sent. It is a safety net and cannot catch every format. */
    function luhnOk(d) {
      var sum = 0, dbl = false;
      for (var i = d.length - 1; i >= 0; i--) {
        var n = d.charCodeAt(i) - 48;
        if (dbl) { n *= 2; if (n > 9) n -= 9; }
        sum += n; dbl = !dbl;
      }
      return sum % 10 === 0;
    }
    function looksSensitive(text) {
      var t = String(text || '').toLowerCase().replace(/\bpin\s*-?\s*codes?\b|\bpincodes?\b/g, ' ');
      var runs = t.match(/\d(?:[ -]?\d){12,22}/g) || [];
      for (var i = 0; i < runs.length; i++) {
        var d = runs[i].replace(/\D/g, '');
        if (d.length >= 13 && d.length <= 19 && luhnOk(d)) return true;
      }
      if (/\b(cvv2?|cvc2?|cvn|security code|card code)\b\D{0,15}\d{3,4}\b/.test(t)) return true;
      var otpWords = '(otp|one[\\s-]?time[\\s-]?(password|code|pin)|verification code|auth(entication)? code|upi pin|mpin|atm pin|card pin|debit pin)';
      if (new RegExp('\\b' + otpWords + '\\b\\D{0,15}\\d{4,8}\\b').test(t)) return true;
      if (new RegExp('\\b\\d{4,8}\\b\\D{0,12}\\b' + otpWords + '\\b').test(t)) return true;
      if (/\b(password|passcode|passwd|pwd)\s*(is\b|:|=)\s*\S{3,}/.test(t)) return true;
      return false;
    }
    function orderHelp(target) {
      var box = el('div', { class: 'pa-mchat__msg pa-mchat__order' });
      var p1 = el('p', null, 'To see your orders, ');
      p1.appendChild(el('a', { href: root + 'account' }, 'sign in to your account'));
      p1.appendChild(document.createTextNode('.'));
      box.appendChild(p1);
      box.appendChild(el('p', null, 'Your order confirmation email also has a \u201cView your order\u201d link that opens your order status page.'));
      box.appendChild(el('p', { class: 'pa-mchat__safe' }, 'I can\u2019t look up, change or cancel orders in this chat.'));
      target.appendChild(box);
    }
    /* ---- end Stage 1c ---- */

    var loadSeq = 0;
    function loadCollection(c, list) {
      var seq = ++loadSeq;
      list.textContent = '';
      list.appendChild(el('p', { class: 'pa-mchat__msg' }, 'Loading ' + (c.title || 'products') + '…'));
      fetch(root + 'collections/' + encodeURIComponent(c.handle) + '/products.json?limit=24', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          if (seq !== loadSeq) return;
          list.textContent = '';
          var products = (data.products || []).filter(function (p) { return (p.variants || []).some(sellable) && !SEARCH_PREFER[p.handle]; });
          if (!products.length) {
            list.appendChild(el('p', { class: 'pa-mchat__msg' }, 'Nothing is available to buy in ' + (c.title || 'this category') + ' right now.'));
            return;
          }
          products.forEach(function (p) { list.appendChild(card(p)); });
          revealList(list);
        })
        .catch(function () {
          if (seq !== loadSeq) return;
          list.textContent = '';
          list.appendChild(el('p', { class: 'pa-mchat__msg', role: 'alert' }, 'Sorry, I couldn’t load products just now. Please try again.'));
        });
    }

    function card(p) {
      var variants = (p.variants || []).filter(sellable);
      var current = variants[0];
      var c = el('div', { class: 'pa-mchat__card' });
      var img = p.images && p.images[0] ? p.images[0].src : '';
      var url = root + 'products/' + p.handle;
      var media = el('a', { href: url, tabindex: '-1', 'aria-hidden': 'true' });
      if (img) {
        media.appendChild(el('img', { src: img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160', alt: '', loading: 'lazy', width: '64', height: '64' }));
      } else {
        media.appendChild(el('span', { class: 'pa-mchat__noimg' }));
      }
      var info = el('div');
      info.appendChild(el('a', { class: 'pa-mchat__title', href: url }, p.title));
      var row = el('div', { class: 'pa-mchat__row' });
      var price = el('span', { class: 'pa-mchat__price' }, money(current.price));
      if (variants.length > 1) {
        var sel = el('select', { class: 'pa-mchat__select', 'aria-label': 'Choose size for ' + p.title });
        variants.forEach(function (v, idx) { sel.appendChild(el('option', { value: String(idx) }, v.title)); });
        sel.addEventListener('change', function () {
          current = variants[Number(sel.value)];
          price.textContent = money(current.price);
        });
        row.appendChild(sel);
      } else if (current.title && current.title !== 'Default Title') {
        row.appendChild(el('span', { class: 'pa-mchat__size' }, current.title));
      }
      row.appendChild(price);
      info.appendChild(row);
      var add = el('button', { class: 'pa-mchat__add', type: 'button' }, 'Add to cart');
      var status = el('div', { class: 'pa-mchat__status', role: 'status' });
      add.addEventListener('click', function () {
        var variant = current;
        add.disabled = true; status.textContent = 'Adding…';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add this item.'); return j; }); })
          .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
          .then(function (cart) {
            status.textContent = '';
            status.appendChild(document.createTextNode('Added to your cart. '));
            status.appendChild(el('a', { href: root + 'cart' }, 'View cart'));
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: 'pa-mchat', data: { source: 'pa-mchat', itemCount: cart.item_count, productId: String(p.id), variantId: String(variant.id) } }
            }));
          })
          .catch(function (e) { status.textContent = (e && e.message) ? e.message : 'Sorry, that didn’t work. Please try again.'; })
          .then(function () { add.disabled = false; });
      });
      info.appendChild(add);
      info.appendChild(status);
      c.appendChild(media); c.appendChild(info);
      return c;
    }

    function open() {
      build();
      panel.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      var f = panel.querySelector('.pa-mchat__chip') || closeBtn;
      f.focus();
    }
    function close() {
      panel.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }
    openBtn.addEventListener('click', function () { if (panel.hidden) open(); else close(); });
    closeBtn.addEventListener('click', close);
    wrap.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { e.stopPropagation(); close(); } });
  }

  function boot() { document.querySelectorAll('[data-pa-mchat]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
